// components/SummaryRow.tsx
import { FC } from 'react';
import { SummaryRowProps } from '../../models/bot';

interface Props extends SummaryRowProps {}

const SummaryRow: FC<Props> = ({ label, value, unit, indent = false }) => (
  <div className={`bot-summary__row ${indent ? 'line-indent' : ''}`}>
    <div className="bot-summary__label">{label}</div>
    <div className="bot-summary__unit">{unit}</div>
    <div className="bot-summary__value">{value}</div>
  </div>
);

export default SummaryRow;
